// https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
import React, { useEffect, useState } from 'react'
import { useLocation } from '@reach/router'
import { Header } from './header'
import { GlobalStyle } from '../theme'
import { PrivacyPolicy } from './privacy-policy'
import { Footer } from './footer'
import './global.css'
import { useCheckLogin } from '../hooks/use-check-login'
import { FloatBar } from './float-bar'
import { Helmet } from 'react-helmet'
import { ContactBar } from './contact-bar'
import { LocaleClass } from '../utils'
import { Main } from './atoms'
import { LOCALE } from '@foxrenderfarm/internals'

interface Props {
  children: React.ReactNode
  /** 应用前缀，如 share、main、support，用于区分不同应用的布局上下文 */
  prefix?: string
  isMultilingual?: boolean
  isSupportPage?: boolean
  hideHeader?: boolean
  displayLanguages?: LOCALE[]
}

export const Layout = ({
  children,
  prefix,
  isMultilingual = false,
  isSupportPage = false,
  hideHeader = false,
  displayLanguages = undefined,
}: Props) => {
  const location = useLocation()
  const locale = LocaleClass.getCurrentLocaleName(location.pathname)
  const [origin, setOrigin] = useState('') // origin 在 useLocation 中为 undefined

  useEffect(() => {
    setOrigin(window.location.origin)
    window.addEventListener('mousemove', loadSalesmartly)

    return () => {
      window.removeEventListener('mousemove', loadSalesmartly)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useCheckLogin()

  const loadSalesmartly = async () => {
    window.removeEventListener('mousemove', loadSalesmartly)
    if (document.querySelector('script[data-salesmartly-script="true"]')) return

    new Promise((resolveScript, rejectScript) => {
      const s = document.createElement('script')
      const s0 = document.getElementsByTagName('script')[0]
      s.defer = true
      s.dataset.salesmartlyScript = 'true'
      s.src = 'https://assets.salesmartly.com/js/project_36837_38457_1704781084.js'
      s.onload = resolveScript
      s.onerror = rejectScript
      s0.parentNode?.insertBefore(s, s0)
    }).catch(console.error)
  }

  return (
    <>
      <Helmet>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}

            gtag('consent', 'default', {
              'ad_storage': 'denied',
              'ad_user_data': 'denied',
              'ad_personalization': 'denied',
              'analytics_storage': 'denied',
              'region': ['GB', 'BE', 'BG', 'CZ', 'DK', 'CY', 'LV', 'LT', 'LU', 'ES', 'FR', 'HR', 'IT', 'PL', 'PT', 'RO', 'SI', 'HU', 'MT', 'NL', 'AT', 'IS', 'LI', 'NO', 'SK', 'FI', 'SE', 'DE', 'EE', 'IE', 'EL']
            });
            gtag('consent', 'default', {
              'ad_storage': 'granted',
              'ad_user_data': 'granted',
              'ad_personalization': 'granted',
              'analytics_storage': 'granted'
            });
            gtag('js', new Date());
            gtag('config', 'G-ZN74J4K3PE');
          `}
        </script>
        {/* <script async src='https://www.googletagmanager.com/gtag/js?id=G-ZN74J4K3PE'></script> */}
      </Helmet>
      {!hideHeader && (
        <Header
          prefix={prefix}
          isMultilingual={isMultilingual}
          currentLocale={locale}
          currentPathname={location.pathname}
          origin={origin}
          displayLanguages={displayLanguages}
        />
      )}
      <Main>{children}</Main>
      {!isSupportPage && <Footer locale={locale} origin={origin} />}
      <PrivacyPolicy />
      <GlobalStyle />
      <FloatBar />
      {/* ContactBar 在最底部要预留高度 */}
      <ContactBar locale={locale} />
    </>
  )
}
